// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/tenant/v1/tenant.proto" (package "c1.api.tenant.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Tenant } from "./tenant";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { IntrospectResponse } from "./tenant";
import type { IntrospectRequest } from "./tenant";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.tenant.v1.Tenant
 */
export interface ITenantClient {
    /**
     * @generated from protobuf rpc: Introspect
     */
    introspect(input: IntrospectRequest, options?: RpcOptions): UnaryCall<IntrospectRequest, IntrospectResponse>;
}
/**
 * @generated from protobuf service c1.api.tenant.v1.Tenant
 */
export class TenantClient implements ITenantClient, ServiceInfo {
    typeName = Tenant.typeName;
    methods = Tenant.methods;
    options = Tenant.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Introspect
     */
    introspect(input: IntrospectRequest, options?: RpcOptions): UnaryCall<IntrospectRequest, IntrospectResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<IntrospectRequest, IntrospectResponse>("unary", this._transport, method, opt, input);
    }
}
